import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Location} from '@angular/common';

@Component({
    selector: 'app-action-buttons-row',
    templateUrl: './action-buttons-row.component.html',
    styleUrls: ['./action-buttons-row.component.scss'],
    standalone: false
})
export class ActionButtonsRowComponent {
  @Input() eventPreviewVisible: boolean = false;
  @Input() eventMeasurementsVisible: boolean = false;
  @Input() saveVisible: boolean = true;
  @Input() cancelVisible: boolean = false;
  @Input() backVisible: boolean = true;
  @Input() disableEditing: boolean = false;
  @Input() saveLabelTranslationKey: string = "app.common.save";
  @Output() onSave: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();
  @Output() onGoToEventPreview: EventEmitter<void> = new EventEmitter<void>();
  @Output() onGoToEventMeasurements: EventEmitter<void> = new EventEmitter<void>();

  constructor(private location: Location) {
  }

  back(): void {
    this.location.back();
  }

  save(): void {
    this.onSave.emit();
  }

  cancel(): void {
    this.onCancel.emit();
  }

  goToEventPreview() {
    this.onGoToEventPreview.emit();
  }

  goToEventMeasurements() {
    this.onGoToEventMeasurements.emit();
  }
}
